import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";

import "../App.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-awesome-reveal";

import Img1 from "../img/Img1.jpg";
import Img2 from "../img/Img2.jpg";
import Img3 from "../img/Img3.jpg";
import Img4 from "../img/Img4.jpg";
import Img5 from "../img/Img5.jpg";
import Img6 from "../img/Img6.jpg";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function Home() {
  return (
    <div className="">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Historias sobre la seguridad hídrica en el Perú</title>
        <meta
          property="og:title"
          content="Historias sobre la seguridad hídrica en el Perú"
        />
        <meta
          name="description"
          content="Serie de reportajes realizados con el fin de generar un mayor debate entre la ciudadanía y los decisores políticos sobre la importancia y eficacia de la infraestructura natural para la gestión sostenible del agua."
        ></meta>
        <meta property="og:url" content={process.env.REACT_APP_URL} />
        <meta
          property="og:image"
          content="https://fundacionmohme.org/especiales/historias-seguridad-hidrica-peru/portada.jpg"
        />
      </Helmet>
      <header className="header">
        <Navbar url="https://fundacionmohme.org/especiales/historias-seguridad-hidrica-peru/" />
        <div className="main-title d-flex align-items-center flex-column text-center">
          <Fade triggerOnce="true" delay="100" duration="1000">
            <h1>Historias sobre la seguridad hídrica en el Perú</h1>
          </Fade>
          <Fade triggerOnce="true" delay="200" duration="1000">
            <p className="bajada mt-2 mt-md-3">
              Nueva serie de reportajes en formatos podcast, cómic, videojuego y
              crónicas sobre la importancia de la infraestructura natural para
              la gestión sostenible del agua en el Perú. Los reportajes fueron
              producidos con el acompañamiento y asesoría de la{" "}
              <a
                href="https://fundacionmohme.org/"
                target="_blank"
                rel="noreferrer"
              >
                Fundación Gustavo Mohme Llona
              </a>
              , en alianza con el Proyecto Infraestructura Natural para la
              Seguridad Hídrica.
            </p>
          </Fade>
        </div>
      </header>
      <div className="bg-container">
        <Container className="container-content">
          <Row className="justify-content-center">
          <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img1})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                      Cauces de vida
                      </h5>
                      <div className="author">
                        <small>
                        Diez relatos en formato podcast a cargo de periodistas del Grupo RPP
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://audioplayer.pe/podcast/cauces-de-vida"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al podcast
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img2})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Historias de lucha por la seguridad hídrica en el Perú
                      </h5>
                      <div className="author">
                        <small>
                          Cuatro reportajes en formato cómic de periodistas de
                          La República
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://especiales.larepublica.pe/seguridad-hidrica-en-el-peru-historias-de-lucha-en-lima-arequipa-piura-y-tacna/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir a los reportajes
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img3})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Prácticas ancestrales para cuidar el agua
                      </h5>
                      <div className="author">
                        <small>
                          Videojuego, crónica y podcast de periodistas de
                          Convoca
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://convoca.pe/cuidadoresdelagua/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al sitio
                    </Button>
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://convoca.pe/newsgames/como-sobrevive-un-anden"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al videojuego
                    </Button>
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://convoca.pe/agenda-propia/los-jueces-que-vigilan-el-agua-en-las-alturas-de-ancash"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir a la crónica
                    </Button>
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://convoca.pe/convoca-radio/mayunmarka-un-pueblo-de-rios-y-costumbres-de-la-sierra-central-del-peru"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al Podcast
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img4})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        La importancia de los reservorios para garantizar el
                        agua
                      </h5>
                      <div className="author">
                        <small>
                          Posdcast producido por periodistas de Radio Cutivalú
                          de Piura
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://soundcloud.com/cutivalu-piura/podcast-reservorios-y-reforestacion-para-la-seguridad-hidrica-en-piura-informe"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al podcast
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img5})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        La tierra de los ojos de agua
                      </h5>
                      <div className="author">
                        <small>
                          Crónica publicada en el diario Correo de Arequipa
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://diariocorreo.pe/edicion/arequipa/arequipa-la-tierra-de-los-ojos-de-agua-noticia/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir a la crónica
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={4} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-start text-left">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${Img6})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Un fondo de vida para Arequipa
                      </h5>
                      <div className="author">
                        <small>
                          Cómic y podcast producidos por periodistas de la
                          región Arequipa
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="p-1">
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://www.yumpu.com/es/document/read/65988189/un-fondo-de-vida-para-arequipa"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al comic
                    </Button>
                    <Button
                      variant="outline-primary" size="sm"
                      href="https://epanoticias.pe/podcast-un-fondo-de-vida-para-arequipa/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ir al podcast
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
